import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRecipientsCount = styled.span.withConfig({
  displayName: "MessageHeaderRecipientCount__StyledRecipientsCount",
  componentId: "sc-1xa3gdi-0"
})(["font-weight:300;margin-right:6px;"]);
const MessageHeaderRecipientCount = ({
  count,
  isForwarded
}) => {
  if (isForwarded && count) {
    return /*#__PURE__*/_jsx(StyledRecipientsCount, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "email-header-forwarded-recipient-count",
        message: "conversations-inbox-message-history.email.messageHeaderForwardedRecipientsCount",
        options: {
          count
        }
      })
    });
  } else if (count > 1) {
    return /*#__PURE__*/_jsx(StyledRecipientsCount, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "email-header-recipient-count",
        message: "conversations-inbox-message-history.email.messageHeaderRecipientsCount",
        options: {
          count
        }
      })
    });
  } else return null;
};
MessageHeaderRecipientCount.displayName = 'MessageHeaderRecipientCount';
export default MessageHeaderRecipientCount;